import { Currency} from '../currency';

export class StripeAccount {
	constructor(data) {
		this.id = data && data.id ? data.id : undefined;
		this.club = data && data.club ? data.club : "";
		this.email = data && data.email ? data.email : "";
		this.currency = data && data.currency ? new Currency(data.currency) : null;
	}
}